// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";

export const mantineTransitionNameSchema = z.union([
	z.literal("fade"),
	z.literal("fade-down"),
	z.literal("fade-up"),
	z.literal("fade-left"),
	z.literal("fade-right"),
	z.literal("skew-up"),
	z.literal("skew-down"),
	z.literal("rotate-right"),
	z.literal("rotate-left"),
	z.literal("slide-down"),
	z.literal("slide-up"),
	z.literal("slide-right"),
	z.literal("slide-left"),
	z.literal("scale-y"),
	z.literal("scale-x"),
	z.literal("scale"),
	z.literal("pop"),
	z.literal("pop-top-left"),
	z.literal("pop-top-right"),
	z.literal("pop-bottom-left"),
	z.literal("pop-bottom-right"),
]);

export const mantineTransitionPropsSchema = z.strictObject({
	transition: mantineTransitionNameSchema.optional(),
	duration: z.number().optional(),
	timingFunction: z.string().optional(),
	keepMounted: z.boolean().optional(),
});
